import * as React from "react";
import { useState } from "react";
import { Spinner, IconButton } from "components/common";
import {
  GranteeInfo,
  GranteeListItemActions,
  GranteeListItemContainer,
  GranteeListItemTitle,
  StyledEntityCreateCapabilitySelect,
  StyledGranteeIcon
} from "components/permissions/CommonStyledComponents";
const CreateGranteesListItem = ({
  availableCapabilities,
  currentGranteeState,
  grantee: { id, capabilityId, type, title },
  onDelete,
  onCapabilityChange
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const handleDelete = () => {
    setIsDeleting(true);
    onDelete(id).then(() => setIsDeleting(false));
  };
  return /* @__PURE__ */ React.createElement(GranteeListItemContainer, { $currentState: currentGranteeState }, /* @__PURE__ */ React.createElement(GranteeInfo, { title }, /* @__PURE__ */ React.createElement(StyledGranteeIcon, { type }), /* @__PURE__ */ React.createElement(GranteeListItemTitle, null, title)), /* @__PURE__ */ React.createElement(
    StyledEntityCreateCapabilitySelect,
    {
      onChange: (newCapabilityId) => onCapabilityChange({ granteeId: id, capabilityId: newCapabilityId }),
      capabilities: availableCapabilities,
      title: `Change the capability for ${title}`,
      value: capabilityId
    }
  ), /* @__PURE__ */ React.createElement(GranteeListItemActions, null, isDeleting ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(IconButton, { name: "delete", onClick: handleDelete, title: `Remove sharing for ${title}` })));
};
export default CreateGranteesListItem;
